import { render, staticRenderFns } from "./PubCustomSelect.vue?vue&type=template&id=2373a88b&scoped=true&"
import script from "./PubCustomSelect.vue?vue&type=script&lang=js&"
export * from "./PubCustomSelect.vue?vue&type=script&lang=js&"
import style0 from "./PubCustomSelect.vue?vue&type=style&index=0&id=2373a88b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2373a88b",
  null
  
)

export default component.exports